export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5251.cf0660b3.jpg";